import React from "react";
import { Navigate } from "react-router-dom";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import { resolveActiveWorkspace, WORKSPACES } from "../../Utils/workspaces";
import Dashboard from "./Dashboard";

export default function DashboardGate() {
  const { userData } = useAuthStore();
  if (resolveActiveWorkspace(userData) === WORKSPACES.STUDENT) {
    return <Navigate to="/student/dashboard" replace />;
  }
  return <Dashboard />;
}
